<!-- @format -->

<ng-container *transloco="let t">
  @if (showDescriptionInfo) {
    <sis-description-list>
      @if (isDegreeProgramme(_module) && _module.learningOutcomes) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.LEARNING_OUTCOMES") }}</dt>
          <dd><sis-localized-markup-string-view [content]="_module.learningOutcomes"></sis-localized-markup-string-view></dd>
        </ng-template>
      }
      @if (_module.contentDescription) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.CONTENT_DESC") }}</dt>
          <dd><sis-localized-markup-string-view [content]="_module.contentDescription"></sis-localized-markup-string-view></dd>
        </ng-template>
      }
      @if (_module.additionalInfo) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.ADDITIONAL_INFO") }}</dt>
          <dd><sis-localized-markup-string-view [content]="_module.additionalInfo"></sis-localized-markup-string-view></dd>
        </ng-template>
      }
      @if (_module.tweetText) {
        <ng-template #listItem>
          <dt>{{ t("MODULE_INFO.TITLE_TWEETTEXT") }}</dt>
          <dd>{{ _module.tweetText | localizedString }}</dd>
        </ng-template>
      }
      @if (isStudyModule(_module)) {
        @if (_module.outcomes) {
          <ng-template #listItem>
            <dt>{{ t("MODULE_INFO.TITLE_OUTCOMES") }}</dt>
            <dd><sis-localized-markup-string-view [content]="_module.outcomes"></sis-localized-markup-string-view></dd>
          </ng-template>
        }
        @if (_module.prerequisites) {
          <ng-template #listItem>
            <dt>{{ t("MODULE_INFO.TITLE_PREREQUISITES") }}</dt>
            <dd><sis-localized-markup-string-view [content]="_module.prerequisites"></sis-localized-markup-string-view></dd>
          </ng-template>
        }
        @if (_module?.searchTags?.length > 0) {
          <ng-template #listItem>
            <dt>{{ t("MODULE_INFO.TITLE_SEARCH_TAGS") }}</dt>
            @for (searchTag of _module.searchTags; track searchTag; let last = $last) {
              <dd>
                {{ searchTag }}
                @if (!last) {
                  <span>,</span>
                }
              </dd>
            }
          </ng-template>
        }
      }
    </sis-description-list>
  } @else {
    <p>{{ t("MODULE_INFO.NO_INFORMATION_GIVEN") }}</p>
  }
</ng-container>
